import { useEffect, useRef, useState } from 'react';
import { Game } from '@/game';
export function GameCanvas() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const gameRef = useRef<Game | null>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [ready, setReady] = useState(false);
  useEffect(() => {
    let cancelled = false;
    const initGame = async () => {
      if (!canvasRef.current || !wrapperRef.current || gameRef.current) return;
      const game = new Game();
      try {
        await game.init(canvasRef.current);
        if (cancelled) {
          game.destroy();
          return;
        }
        gameRef.current = game;
        setReady(true);
      } catch (error) {
        console.error('[GameCanvas] Failed to initialize Pixi game', error);
      }
    };
    void initGame();
    return () => {
      cancelled = true;
      if (gameRef.current) {
        gameRef.current.destroy();
        gameRef.current = null;
      }
      setReady(false);
    };
  }, []);
  // Keep the canvas CSS-sized to its wrapper while the Pixi backing buffer
  // stays at init-time resolution. This preserves aspect ratio and crispness.
  useEffect(() => {
    const wrapper = wrapperRef.current;
    const canvas = canvasRef.current;
    if (!wrapper || !canvas) return;
    const handleResize = () => {
      const rect = wrapper.getBoundingClientRect();
      if (rect.width > 0) canvas.style.width = `${rect.width}px`;
      if (rect.height > 0) canvas.style.height = `${rect.height}px`;
    };
    handleResize();
    const observer = new ResizeObserver(handleResize);
    observer.observe(wrapper);
    return () => observer.disconnect();
  }, [ready]);
  return (
    <div
      ref={wrapperRef}
      className="relative w-full h-full flex items-center justify-center overflow-hidden bg-gradient-to-b from-indigo-900 via-slate-900 to-amber-950"
    >
      <canvas
        ref={canvasRef}
        className="block"
      />
    </div>
  );
}